import styled from "styled-components";

export const InstantReqPageSuccessStyled = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;

  & > .inner {
    width: 270px;
    margin: auto;
    .inner__white {
      padding: 12px;
      border-radius: 14px;
      width: 100%;
      background-color: #ffffff;

      .header {
        .img {
          width: 50px;
          height: 50px;
          border-radius: 8px;
          border: solid 1px #2a2e43;
          background-color: rgba(42, 46, 67, 0.2);
        }
      }

      .distance {
        background-color: #f4f4f5;
        border-radius: 10px;
      }

      .vehicle-images {
        display: flex;
        align-items: center;
        justify-content: space-between;

        > div {
          overflow: hidden;
          background-color: rgba(42, 46, 67, 0.2);
          border: solid 1px #2a2e43;
          width: 48px;
          height: 48px;
          border-radius: 8px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }

      .bottom-btns {
        font-size: 1.1em;

        > button {
          padding: 5px;
          border-radius: 10px;
          background-color: #f4f4f5;
          flex-grow: 2;
        }

        > button:last-child {
          background-color: #2a2e43;
          box-shadow: 0 4px 10px 0 rgba(42, 46, 67, 0.2);
          color: white;
          margin-right: 12px;
        }
      }
    }
  }
`;
